(function () {
  function initStoreDetailGalleries() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.js-store-detail-gallery').forEach(function (el) {
      if (el.dataset.swiperInitialized === 'true') return;

      var slides = el.querySelectorAll('.swiper-slide');
      var count = slides.length;
      if (count === 0) return;

      el.dataset.swiperInitialized = 'true';

      var prev = el.querySelector('.swiper-button-prev');
      var next = el.querySelector('.swiper-button-next');

      new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: count > 1,
        watchOverflow: true,
        keyboard: { enabled: true, onlyInViewport: true },
        navigation:
          prev && next
            ? {
                prevEl: prev,
                nextEl: next,
              }
            : undefined,
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoreDetailGalleries);
  } else {
    initStoreDetailGalleries();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('.js-store-detail-gallery')) {
      initStoreDetailGalleries();
    }
  });
})();
